import { render } from "./ProjectPreview.vue?vue&type=template&id=138afadc&scoped=true&ts=true"
import script from "./ProjectPreview.vue?vue&type=script&lang=ts"
export * from "./ProjectPreview.vue?vue&type=script&lang=ts"

import "./ProjectPreview.vue?vue&type=style&index=0&id=138afadc&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138afadc"]])

export default __exports__